import { rest } from 'msw';

const getUser = rest.get('/api/user', (req, res, ctx) => {
  return res(ctx.status(200), ctx.json({ isAuthenticated: false }));
});

export const handlers = [getUser];
